<script lang="ts">
  import { toastStore, toast } from '@lib/store/toast'
  import { fly, fade } from 'svelte/transition'

  const getIcon = (type: string) => {
    switch (type) {
      case 'success': return 'check_circle'
      case 'error': return 'error'
      case 'warning': return 'warning'
      case 'info': return 'info'
      case 'progress': return 'downloading'
      default: return 'info'
    }
  }

  const getClass = (type: string) => {
    switch (type) {
      case 'success': return 'alert-success'
      case 'error': return 'alert-error'
      case 'warning': return 'alert-warning'
      case 'info': return 'alert-info'
      case 'progress': return 'alert-info'
      default: return 'alert-info'
    }
  }
</script>

<div class="toast-container">
  {#each $toastStore as notification (notification.id)}
    <div
      class="toast-alert {getClass(notification.type)}"
      in:fly={{ x: 100, duration: 300 }}
      out:fade={{ duration: 200 }}
    >
      <span class="material-icons toast-icon">{getIcon(notification.type)}</span>
      <div class="toast-body">
        <span class="toast-message">{notification.message}</span>
        {#if notification.type === 'progress' && notification.progress !== undefined}
          <div class="toast-progress-track">
            <div class="toast-progress-bar" style="width: {notification.progress}%"></div>
          </div>
        {/if}
      </div>
      <button
        class="toast-close"
        onclick={() => toast.remove(notification.id)}
      >
        <span class="material-icons">close</span>
      </button>
    </div>
  {/each}
</div>

<style>
  .toast-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
  }

  .toast-alert {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 300px;
    max-width: 500px;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    pointer-events: auto;
  }

  .toast-alert.alert-success {
    background: theme('colors.success');
    color: theme('colors.success-content');
  }

  .toast-alert.alert-error {
    background: theme('colors.error');
    color: theme('colors.error-content');
  }

  .toast-alert.alert-warning {
    background: theme('colors.warning');
    color: theme('colors.warning-content');
  }

  .toast-alert.alert-info {
    background: theme('colors.info');
    color: theme('colors.info-content');
  }

  .toast-icon {
    font-size: 24px;
    flex-shrink: 0;
  }

  .toast-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .toast-message {
    font-size: 14px;
  }

  .toast-progress-track {
    width: 100%;
    height: 4px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    overflow: hidden;
  }

  .toast-progress-bar {
    height: 100%;
    background: currentColor;
    border-radius: 2px;
    transition: width 0.3s ease;
    opacity: 0.8;
  }

  .toast-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    background: transparent;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    color: currentColor;
    flex-shrink: 0;
  }

  .toast-close:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  .toast-close .material-icons {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    .toast-container {
      top: 8px;
      left: 8px;
      right: 8px;
      bottom: auto;
      align-items: center;
    }

    .toast-alert {
      min-width: 0;
      max-width: 100%;
      width: 100%;
      padding: 10px 12px;
      font-size: 13px;
      gap: 8px;
    }

    .toast-icon {
      font-size: 20px;
    }

    .toast-message {
      font-size: 13px;
    }

    .toast-close {
      width: 24px;
      height: 24px;
    }

    .toast-close .material-icons {
      font-size: 16px;
    }
  }
</style>